import React from "react";
import toast from "react-hot-toast";
import { useLazyGetDocumentOpenUrlQuery } from "../services/clientdocuments";

// TODO: modify this so that we have a method for displaying the data within a modal

export type OpenDocumentResponse = {
    url: string,
    code: number,
    message: string | null | undefined
};

export type OpenDocumentHookProps = {
    isLoading: boolean,
    openDocument: (documentId: string, fileName?: string | null) => Promise<void>
};

const useOpenDocument = () : OpenDocumentHookProps => {
    const [getDocumentOpenUrl, results] = useLazyGetDocumentOpenUrlQuery();

    const openDocument = (documentId: string, fileName: string | null = null) => {
        return toast.promise<OpenDocumentResponse>(getDocumentOpenUrl({ documentId }).unwrap(), {
            loading: `Opening ${(fileName !=  null && fileName.length > 0) ? `'${fileName}'` : 'Document'}...`,
            success: null,
            error: (err) => err?.data?.message ?? 'There was a problem trying to open the document.'
        }).then(
            (r: OpenDocumentResponse) => {
                if (r.url && r.url.length > 0) {
                    window.open(r.url);
                }
            }
        );
    };

    return { ...results, openDocument };
};

export default useOpenDocument;